import { analyticsClick } from "@/lib/analytics/props";
import type { FrameModel } from "@/lib/model/Frame";

interface Props {
    frame: FrameModel;
    onClick: () => void;
    priority?: boolean;
}

export const FrameCard: React.FC<Props> = ({ frame, onClick, priority = false }) => {
    const { name, frameDetailSampleImageUrl, sampleImageUrl, layout } = frame;

    const [row, col] = layout.split("x").map(Number);
    const isVertical = row > col;

    const imageStyle = { 
      width: isVertical ? "auto" : "100%",
      height: isVertical ? "100%" : "auto",
      boxShadow: "1px 1px 4px 2px #BEBEBE",
      maxHeight: "150px",
      maxWidth: 'unset',
    };

    return (
        <div
        className="p-2 flex flex-col items-center justify-center min-h-[100px] relative"
        onClick={onClick}
        {...analyticsClick({ event: "frame-card", feature: "navigation", location: window.location.pathname, label: name })}
      >
        {frame.isCollabFrame && (
          <img src="/star.png" alt="Collab frame" className="absolute -top-[5px] -right-[15px] w-12 h-12 pointer-events-none" />
        )}
        <img
          src={frameDetailSampleImageUrl || sampleImageUrl}
          alt={`${name} photo frame preview`}
          loading={priority ? "eager" : "lazy"}
          fetchPriority={priority ? "high" : "auto"}
          decoding="async"
          style={imageStyle}
        />
      </div>
    )
}